import './DragAndDrop.scss';

import { Button as AntdButton, Modal } from 'antd';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import delete_icon from '../../assets/images/MembersArea/MyProfile/delete_icon_profile.svg';
import { SET_PROFILE_AVATAR } from '../../redux/types/profileAvatar';
import { authMe } from '../../services/auth-service/auth.service';
import {
  deleteGalleryImage,
  updateProfilePictures,
} from '../../services/profile-service/profile.service';
import { getToken } from '../../services/token-service/token.service';
import { setUserLocalData } from '../../services/user-service/user.service';
import Button from '../Button/Button';
import ImageComponentPreview from '../ImageComponentPreview/ImageComponentPreview';
import ImageNPreview from '../ImageNPreview/ImageNPreview';
import LoaderComponent from '../LoaderCompoment/LoaderComponent';
import SuccessMessage from '../SuccessMessage/SuccessMessage';

const DragAndDrop = (props) => {
  const {
    fileRef,
    userID,
    multiple,
    type,
    text,
    btnText,
    dndImage,
    successMessage,
    failureMessage,
    currentPhoto,
    setCurrentPhoto,
    currentPhotoFullSize,
  } = props;
  const token = getToken();
  const [showSuccesMessage, setShowSuccesMessage] = useState(false);
  const [showFailureMessage, setShowFailureMessage] = useState(false);
  const dispatch = useDispatch();
  const { profileAvatar } = useSelector((state) => state);
  const [loader, setLoader] = useState(false);

  const [newPhoto, setNewPhoto] = useState('');
  const [, setDragAndDropImage] = useState(dndImage);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModalDelete = () => {
    console.log('MODAL');
    setIsModalVisible(true);
  };

  const handleCancelModal = () => {
    setIsModalVisible(false);
  };

  const classes = ['drag-drop-zone'];
  if (props.className) {
    classes.push(props.className);
  }

  const textClasses = ['drag-drop-text'];
  if (props.textClasses) {
    textClasses.push(props.textClasses);
  }

  const btnclasses = ['button-wrapper'];
  if (props.btnclasses) {
    btnclasses.push(props.btnclasses);
  }

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const uploadPhotoFailed = (err) => {
    console.log(err);
    setShowFailureMessage(true);
    setLoader(false);
  };

  const uploadPhotoSuccess = (urlData) => {
    console.log('URL DATA', urlData);
    dispatch({ type: SET_PROFILE_AVATAR, payload: urlData });
    authMe().then((res) => {
      setUserLocalData(res.data);
    });
    setShowSuccesMessage(true);
    setLoader(false);
  };

  const deletePhotoSuccess = () => {
    dispatch({ type: SET_PROFILE_AVATAR, payload: '' });
    authMe().then((res) => {
      setUserLocalData(res.data);
      setDragAndDropImage(dndImage);
      setNewPhoto('');
      setCurrentPhoto && setCurrentPhoto('');
      setShowSuccesMessage(true);
      setLoader(false);
      setIsModalVisible(false);
    });
  };

  const deletePhotoFailed = (err) => {
    console.log(err);
    setShowFailureMessage(true);
    setLoader(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const formData = new FormData();
    const fileArray = Array.from(e.dataTransfer.files);

    if (multiple) {
      for (let i = 0; i < e.dataTransfer.files.length; i++) {
        formData.append(`${type}[]`, e.dataTransfer.files[i]);
      }
    } else {
      formData.append(type, fileArray[0]);
    }

    // const reader = new FileReader();
    // reader.onload = () => {
    //   if (reader.readyState === 2) {
    //     setNewPhoto(reader.result);
    //   }
    // };
    // reader.readAsDataURL(e.dataTransfer.files[0]);

    setLoader(true);
    setNewPhoto('');

    updateProfilePictures(formData, userID, token)
      .then(async () => {
        const profileData = await authMe();
        const urlData = profileData.data.data.profile.avatar_image?.thumbnail_url;
        uploadPhotoSuccess(urlData);
      })
      .then(() => {
        const reader = new FileReader();
        reader.onload = () => {
          if (reader.readyState === 2) {
            setNewPhoto(reader.result);
          }
        };
        reader.readAsDataURL(e.target.files[0]);
      })
      .catch(uploadPhotoFailed);
  };

  const selectFile = (ref) => {
    ref.current.click();
  };

  const onBrowsedFileSelected = (e) => {
    const formData = new FormData();
    const fileArray = Array.from(e.target.files);

    if (multiple) {
      for (let i = 0; i < e.target.files.length; i++) {
        formData.append(`${type}[]`, e.target.files[i]);
      }
    } else {
      formData.append(type, fileArray[0]);
    }

    console.log('e.target.files ==> ', e.target.files);
    console.log('fileArray ==> ', fileArray);
    console.log('formData ==> ', formData);

    setLoader(true);
    setNewPhoto('');
    updateProfilePictures(formData, userID, token)
      .then(async () => {
        const profileData = await authMe();
        const urlData = profileData.data.data.profile.avatar_image?.thumbnail_url;
        uploadPhotoSuccess(urlData);
      })
      .then(() => {
        const reader = new FileReader();
        reader.onload = () => {
          if (reader.readyState === 2) {
            setNewPhoto(reader.result);
          }
        };
        reader.readAsDataURL(e.target.files[0]);
      })
      .catch(uploadPhotoFailed);
  };

  const handleOk = async (token) => {
    const profileData = profileAvatar?.split('/thumbnail/')[1];
    deleteGalleryImage(profileData, token).then(deletePhotoSuccess).catch(deletePhotoFailed);
  };

  return (
    <div
      className={classes.join(' ')}
      onDrop={(e) => handleDrop(e)}
      onDragOver={(e) => handleDragOver(e)}
      onDragEnter={(e) => handleDragEnter(e)}
      onDragLeave={(e) => handleDragLeave(e)}
    >
      <SuccessMessage
        className="success-message"
        message={successMessage}
        showMessage={showSuccesMessage}
        setShowMessage={setShowSuccesMessage}
      />
      <SuccessMessage
        className="failure-message"
        message={failureMessage}
        showMessage={showFailureMessage}
        setShowMessage={setShowFailureMessage}
      />
      {/* {dndImage && <img alt="drag and drop icon" src={dndImage}></img>} */}
      {loader ? (
        <div className="LoaderComponentWrapper">
          <LoaderComponent />
        </div>
      ) : newPhoto ? (
        <div className="ProfileImageWrapper">
          <div className="ImageContainer">
            <ImageComponentPreview url={newPhoto} />
            <div className="DeleteIconWrapperProfie" id="button-wrapper" onClick={showModalDelete}>
              <img alt="delete icon" src={delete_icon} className="DeleteIconProfile"></img>
            </div>
          </div>
        </div>
      ) : currentPhoto ? (
        <div className="ProfileImageWrapper">
          <div className="ImageContainer">
            <ImageNPreview name={currentPhoto} nameFullSize={currentPhotoFullSize} />
            <div className="DeleteIconWrapperProfie" onClick={showModalDelete}>
              <img alt="delete icon" src={delete_icon} className="DeleteIconProfile"></img>
            </div>
          </div>
        </div>
      ) : (
        <>
          <img alt="drag and drop icon" src={dndImage}></img>{' '}
          <p className={textClasses.join(' ')}>{text}</p>
        </>
      )}

      <div onClick={selectFile.bind(null, fileRef)} className="DefaultButton">
        <Button text={btnText} className={btnclasses.join(' ')} />
        <input
          type="file"
          ref={fileRef}
          name="messagePhotos"
          accept=".png,.jpg,.jpeg"
          hidden
          multiple={multiple}
          onChange={onBrowsedFileSelected}
        />
      </div>
      <Modal
        className="DeleteModal"
        title="Delete photo"
        visible={isModalVisible}
        // onOk={hideModal}
        onCancel={handleCancelModal}
        footer={[
          <AntdButton key="back" onClick={handleCancelModal}>
            No
          </AntdButton>,
          <AntdButton
            key="submit"
            type="primary"
            onClick={() => {
              handleOk();
            }}
          >
            Yes
          </AntdButton>,
        ]}
      >
        <p className="DeletePhotoText">Are you sure you want to delete this photo?</p>
      </Modal>
    </div>
  );
};
export default DragAndDrop;
